module.exports = new __parcel__URL__("WhiteboardTeammateLight.c29609b9.svg").toString();